import { AppConstants } from '../../utils/appConstants.class';
import { ConnectionCheck } from '../../utils/connection-check';
import { environment } from '../../../environments/environment';
import { Predicate } from '@angular/core';

export class BaseService {
  constructor() {}

  public isManager = environment.isManager;

  public get isConnection() {
    return ConnectionCheck.isConnection;
  }

  public get applicationType(): number {
    const type = sessionStorage.getItem(AppConstants.CURRENT_APP_TYPE);
    if (type) {
      return +type;
    }
    return null;
  }

  public get applicationTypeName(): string {
    const type = this.applicationType;
    if (type == null) return null;

    switch (type) {
      case 0:
        return 'maintenance';
      case 1:
        return 'optimization';
      case 2:
        return 'installation';
      default:
        return 'maintenance';
    }
  }

  public get currentUserId(): string {
    return localStorage.getItem(AppConstants.CURRENT_USER);
  }

  public get currentUserName(): string {
    return localStorage.getItem(AppConstants.CURRENT_USER_NAME);
  }

  get offlineInspectionId() {
    return localStorage.getItem(`${AppConstants.OFFLINE_INSPECTION}_${this.currentUserId}`);
  }

  get sessionId() {
    return sessionStorage.getItem(AppConstants.SESSION_ID);
  }

  public isInspectionInOffline(inspectionId) {
    return this.offlineInspectionId === inspectionId;
  }

  protected some(predicates: Predicate<any>[]): Predicate<any> {
    return (e) => predicates.some((p) => p(e));
  }
}
